import { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw[] = [
    {
        path: '/auth',
        component: () => import('@/core/views/layouts/auth/AuthLayout.vue'),
        children: [
            {
                path: 'signin',
                name: 'signin',
                component: () => import('@/core/auth/views/AuthSignin.vue')
            },
            {
                path: 'signup',
                name: 'signup',
                component: () => import('@/core/auth/views/AuthSignup.vue'),
                meta: { allowUnauthenticated: true }
            },
            {
                path: 'forgot-password',
                name: 'forgotPassword',
                component: () => import('@/core/auth/views/AuthForgotPassword.vue'),
                meta: { allowUnauthenticated: true }
            },
            {
                path: 'reset-password',
                name: 'auth-reset-password',
                component: () => import('@/shared/components/auth/ResetPasswordFlow.vue'),
                props: (route) => ({
                    email: route.query.email,
                    token: route.query.token
                }),
                meta: { allowUnauthenticated: true }
            },
            {
                path: 'reset-password-profile',
                name: 'resetPassword',
                component: () => import('@/modules/admin/profile/views/ResetPassword.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '',
                redirect: { name: 'signin' }
            }
        ]
    }
]

export default authRoutes
